module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_Filter Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_Filter', {

		configure: function () {
			this.MONTHS = [
				'January', 'February', 'March',
				'April', 'May', 'June',
				'July', 'August', 'September',
				'October', 'November', 'December'
			];

			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_filter',
				widgets: {
					periodTypeSelector: {
						widget: 'Tools_TabsSwitcher',
						target: '.activity-period-type .type',
						name: 'period-type',
						callback: '@parent:switchPeriodFilter',
						switchOnEmbed: true
					},
					periodNavigator: {
						widget: 'Widget',
						autoRender: false,
						'embed.container': '.activity-period-date',
						template: 'activity_event_period_navigator',
						'hooks.onStartRendering': '@parent:onNavRender'
					},
					viewSettingList: {
						widget: 'List',
						autoRender: false,
						'embed.container': '.setup-list',
						'tpl.row': 'activity_event_view_settings_row'
					}
				},
				handleDom: {
					toogleSettings: {
						event: 'click',
						target: '.activity-view-settings .type',
						callback: 'toogleSettings'
					},
					toogleOption: {
						event: 'click',
						target: '.switch-wrapper',
						targetWidget: '#viewSettingList',
						callback: 'toogleOption'
					},
					navigatePeriod: {
						event: 'click',
						target: '.period-direction',
						targetWidget: '#periodNavigator',
						callback: 'navigatePeriod'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.activePeriodType = 'month';
			this.viewSettings = {
				1: {visible: 1, name: 'liveshow', status: 1},
				2: {visible: 1, name: 'blogPost', status: 1},
				3: {visible: 0, name: 'message', status: 0},
				4: {visible: 0, name: 'trip', status: 0},
				5: {visible: 1, name: 'custom', status: 1},
				6: {visible: 1, name: 'photoset', status: 1},
				7: {visible: 1, name: 'video', status: 1}
			};	
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.pNav = this.rwom1('#periodNavigator');

			this.setPeriod(this.getPeriodRange(this.activePeriodType, 'next'));

			// temp
			this.rwom1('#viewSettingList').setCollection(this.viewSettings, true);
		
			this.callParent('running', arguments);
		},

		activate: function (argument) {
			this.dispatchData();
			this.callParent('activate', arguments);
		},

		setPeriod: function (period) {
			this.activePeriod = period;

			this.dispatchData();

			return this.pNav && this.pNav.render();
		},

		dispatchData: function () {
			var data, cacheNext, cachePrev;

			cacheNext = this.getPeriodRange(this.activePeriodType, 'next',  this.activePeriod.finish.parts.day, this.activePeriod.finish.parts.month, this.activePeriod.finish.parts.year);
			cachePrev = this.getPeriodRange(this.activePeriodType, 'prev',  this.activePeriod.start.parts.day, this.activePeriod.start.parts.month, this.activePeriod.start.parts.year);

			data = {
				current: {
					durationFrom: this.activePeriod.start.timestamp,
					durationTo: this.activePeriod.finish.timestamp,
					types: this.getViewSettings(),
				},
				next: {
					durationFrom: cacheNext.start.timestamp,
					durationTo: cacheNext.finish.timestamp,
					types: this.getViewSettings()
				},
				prev: {
					durationFrom: cachePrev.start.timestamp,
					durationTo: cachePrev.finish.timestamp,
					types: this.getViewSettings()
				}
			}

			this.dispatchEvent('filterChanged', data);

			return data;
		},

		getPeriodRange: function (periodType, direction, day, month, year) {
			var todayObj, day, month, year, period, startPeriod, finishPeriod;

			todayObj = new Date();
			day = day || todayObj.getDate();
			month = month === 0 ? 0 : month || todayObj.getMonth();
			year = year || todayObj.getFullYear();

			period = periodType === 'day'
				? 1
				: periodType === 'week'
				 	? 7
				 	: periodType === 'month'
				 		? fox.utils.daysInMonth(month)
				 		: 7;

			switch (direction) {
				case 'next':
					startPeriod = [year, month, day];

					if ((day = fox.utils.daysInMonth(month) - day - period) < 0) {
						day *= -1;

						if (month !== 11) {
							month += 1;
						} else {
							month = 0;
							year += 1;
						}
					} else {
						day = fox.utils.daysInMonth(month) - day;
					}

					finishPeriod = [year, month, day];
					break;
				case 'prev':
					finishPeriod = [year, month, day];

					if ((day = day - period) <= 0) {
						if (month !== 0) {
							month -= 1;
						} else {
							month = 11;
							year -= 1;
						}
						
						day = Math.abs(fox.utils.daysInMonth(month) + day);
					}

					startPeriod = [year, month, day];
					break;
			}
			
			return {
				start: {
					timestamp: new Date(startPeriod[0], startPeriod[1], startPeriod[2]).getTime(),
					parts: {
						year: startPeriod[0],
						month: startPeriod[1],
						day: startPeriod[2]
					}
				},
				finish: {
					timestamp: new Date(finishPeriod[0], finishPeriod[1], finishPeriod[2]).getTime(),
					parts: {
						year: finishPeriod[0],
						month: finishPeriod[1],
						day: finishPeriod[2]
					}
				},
				result: this.getHRD(startPeriod, finishPeriod, period)
			}
		},

		getHRD: function (startPeriod, finishPeriod, period) {
			var result;

			if (period === 1) {
				result = [[this.MONTHS[startPeriod[1]], startPeriod[2]].join(' - '), startPeriod[1] === 11 ? startPeriod[0] : finishPeriod[0]].join(', ');
			} else if (startPeriod[1] !== finishPeriod[1]){
				result = [[this.MONTHS[startPeriod[1]], startPeriod[2]].join(' - '), [this.MONTHS[finishPeriod[1]], finishPeriod[2]].join(' - '), finishPeriod[0]].join(', ');
			} else if (startPeriod[1] === finishPeriod[1]) {
				result = [this.MONTHS[startPeriod[1]], [startPeriod[2], finishPeriod[2]].join(' - '), finishPeriod[0]].join(', ');
			}
			return result;
		},

		toogleSettings: function (el) {
			if ($(el.parentNode).hasClass('opened')) {
				$(el.parentNode).removeClass('opened');
			} else {
				$(el.parentNode).addClass('opened');
			}
		},

		toogleOption: function (el) {
			var $el;

			$el = $(el);

			if ($el.hasClass('on')) {
				$el.removeClass('on').addClass('off');
				this.viewSettings[$el.data('card-type')].status = 0;
			} else if ($el.hasClass('off')) {
				$el.removeClass('off').addClass('on');
				this.viewSettings[$el.data('card-type')].status = 1;
			}

			this.dispatchData();
		},

		switchPeriodFilter: function (periodType) {
			this.activePeriodType = periodType;

			this.setPeriod(
				this.getPeriodRange(this.activePeriodType, 'next',
					this.activePeriod.start.parts.day,
					this.activePeriod.start.parts.month,
					this.activePeriod.start.parts.year
				)
			);
		},

		onNavRender: function () {
			this.pNav.setTemplateOptions('result', this.activePeriod.result);

			return true;
		},

		navigatePeriod: function (el) {
			var $el, direction, dayFrom, monthFrom, yearFrom;

			$el = $(el);
			direction = $el.data('direction');

			dayFrom = this.activePeriod[direction === 'next' ? 'finish' : 'start'].parts.day;
			monthFrom = this.activePeriod[direction === 'next' ? 'finish' : 'start'].parts.month;
			yearFrom = this.activePeriod[direction === 'next' ? 'finish' : 'start'].parts.year;

			this.setPeriod(this.getPeriodRange(this.activePeriodType, direction, dayFrom, monthFrom, yearFrom));
		},

		getViewSettings: function () {
			var settings = {};

			fox.each(this.viewSettings, function (val, key) {
				settings[key] = val.status;
			});

			return settings;
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/filter.js
// module id = 785
// module chunks = 4